export default function MemberDetails({ member }) {
  return [member.name, member.email].filter(Boolean).join(' - ');
}
